import React, { useContext, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useShowDeliveryUnavailableBanner } from '@/vdp/DeliveryUnavailableBanner';
import GlobalContext from '~/context/vdp/GlobalContext';
import { useCssProp } from '~/hooks/common';
import { getCtaButtonState } from '~/selectors';

function usePageHeaderHeight<
  T extends HTMLElement = HTMLElement
>(): React.RefObject<T> {
  const { headerHeight, setHeaderHeight } = useContext(GlobalContext);
  const ref = useRef<T>(null);
  const { notifyMe } = useSelector(getCtaButtonState);
  const showDeliveryUnavailableBanner = useShowDeliveryUnavailableBanner();

  useEffect(() => {
    if (!ref.current) return;
    const computedHeaderHeight =
      ref.current.getBoundingClientRect().top + window.scrollY;
    setHeaderHeight(computedHeaderHeight);
  }, [notifyMe, setHeaderHeight, showDeliveryUnavailableBanner]);

  useCssProp(ref, 'header-height', headerHeight);

  return ref;
}

export default usePageHeaderHeight;
